<template>
    <v-card-text>
      <v-row class="pa-3 mb-0">
        <v-col cols="12" xs="12" v-if="!!form.title && form.title.length > 0">
          <h3 class="text-center">{{ form.title }}</h3>
        </v-col>
        <v-col cols="12" xs="12" v-if="!!form.description && form.description.length > 0">
          <p class="text-center" v-html="form.description.replaceAll('\n','<br/>')"></p>
        </v-col>
        <v-col
          cols="12"
          v-for="(element, i) in elements"
          :key="i"
          :md="parseFlex(element.element_flex_size).md"
          :sm="parseFlex(element.element_flex_size).sm"
          :xs="parseFlex(element.element_flex_size).xs"
        >
          <TextFieldComponent
            v-if="['text','multiNumbers','number','phone','url'].includes(element.element_type)"
            v-model="innerValue['element_' + element.element_id]" 
            :label="element.element_title"
            :hint="element.element_guidelines"
            :isRequired="element.element_is_required == '1'"
            :isSearchable="element.element_is_searchable == '1'"
            :isCurrency="element.element_is_currency == '1'"
            :dir="parseDir(element.element_type)"
            :keyboardType="parseKeyboardType(element.element_type)"
          />
          <TextAriaComponent
            v-else-if="element.element_type == 'textarea'"
            v-model="innerValue['element_' + element.element_id]" 
            :label="element.element_title"
            :hint="element.element_guidelines"
            :isRequired="element.element_is_required == '1'"
          />
          <SelectComponent
            v-else-if="element.element_type == 'select'"
            v-model="innerValue['element_' + element.element_id]" 
            :label="element.element_title"
            :hint="element.element_guidelines"
            :isRequired="element.element_is_required == '1'"
            :options="element.element_options"
          />
          <SelectComponent
            v-else-if="element.element_type == 'weekdays'"
            v-model="innerValue['element_' + element.element_id]" 
            :label="element.element_title"
            :hint="element.element_guidelines"
            :isRequired="element.element_is_required == '1'"
            :options="weekDaysOptions"
            :isMultiple="element.element_is_multiple == '1'"
          />
          <!-- TODO: Calc Automation -->
          <DateComponent
            v-else-if="element.element_type == 'date'"
            v-model="innerValue['element_' + element.element_id]" 
            :label="element.element_title"
            type="date" format="YYYY-MM-DD"
            :display_format="element.element_date_is_eng == '1'?'YYYY-MM-DD':'jYYYY-jMM-jDD'"
            :locale="element.element_date_is_eng == '1' ? 'en' : 'fa'"
          />
          <DateComponent
            v-else-if="element.element_type == 'time'"
            v-model="innerValue['element_' + element.element_id]" 
            :label="element.element_title"
            type="time" format="HH:mm"
            display_format="HH:mm"
            :locale="element.element_date_is_eng == '1' ? 'en' : 'fa'"
          />
          <template
            v-else-if="element.element_type == 'checkbox'"
            >
              {{ element.element_title }}
              <v-icon v-if="element.element_is_required == '1'" size="x-small" color="error" style="font-size: 8px;">fa fa-circle</v-icon>
              <CheckboxComponent
                v-for="(optioncheckboxItem,index) in element.element_options"
                :key="`optioncheckboxItem`+index"
                v-model="innerValue['element_'+element.element_id+'_'+optioncheckboxItem.option_id]"
                :label="optioncheckboxItem.option"
                />
              {{ element.element_guidelines }}
          </template>
          <template v-else-if="element.element_type == 'radio'" >
              {{ element.element_title }}
              <v-icon v-if="element.element_is_required == '1'" size="x-small" color="error" style="font-size: 8px;">fa fa-circle</v-icon>
              <RadioComponent
                v-model="innerValue['element_' + element.element_id]" 
                :options="element.element_options"
                />
              {{ element.element_guidelines }}
          </template>
          <template v-else-if="element.element_type == 'file'" >
              {{ element.element_title }}
              <v-icon v-if="element.element_is_required == '1'" size="x-small" color="error" style="font-size: 8px;">fa fa-circle</v-icon>
              
              {{ element.element_guidelines }}
          </template>
          <v-divider v-else-if="element.element_type == 'line'"/>
          <v-alert v-else type="error" color="error" >
          المنت مشخص نیست
          {{ element.element_type }}
          </v-alert>
        </v-col>
        <v-col  cols="12" xs="12" class="pa-1" v-if="elements.length > 0">
          <v-btn
            :loading="loading"
            @click="submitForm"
            block
            color="success"
          >
            {{ !!innerValue["id"]?form.form_review_primary_text:form.form_submit_primary_text }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
</template>

<script>
// این کامپوننت هایی هست که استفاده شده
import CheckboxComponent from '@/components/form/CheckboxComponent.vue';
import TextFieldComponent from '@/components/form/TextFieldComponent.vue';
import TextAriaComponent from '@/components/form/TextAriaComponent.vue';
import SelectComponent from '@/components/form/SelectComponent.vue';
import DateComponent from '@/components/form/DateComponent.vue';
import RadioComponent from '@/components/form/RadioComponent.vue';
export default {
    name: "FormPage",
    props: {
      modelValue: {
        type: Object,
        default:  () => {}
      },
      form_elements: {
        type: Array,
        default: () => []
      },
      form: {
        type: Object,
        default: () => {}
      },
      loading: {
        type: Boolean,
        default: () => false
      },
    },
    data() {
      return {
        innerValue: this.modelValue,
      }
    },
    
    components: {
        CheckboxComponent,
        TextFieldComponent,
        TextAriaComponent,
        SelectComponent,
        DateComponent,
        RadioComponent,
    },
    methods:{
      submitForm(){
        this.$emit("submit",this.innerValue)
      },
      parseFlex(flexString) {
        const flexObj = {};
        flexString.split(' ').forEach(item => {
          const key = item.slice(0, 2); // دو حرف اول را به عنوان کلید می‌گیریم
          const value = item.slice(2);   // باقی‌مانده را به عنوان مقدار می‌گیریم
          flexObj[key] = value;
        });
        return flexObj;
      },
      parseDir(type) {
        return ["multiNumbers", "number","phone","url"].includes(type) ? 'ltr' : 'rtl';
      },
      parseKeyboardType(type){
        switch (type) {
          case "phone":
            return "number";
          case "url":
            return "url";
          case "multiNumbers":
            return "number";
          case "date":
            return "date";
          default:
            return "text";
        }
      },
    },
    computed:{
      elements(){
        return this.form_elements;
      }
    },
    watch: {
      modelValue(val) {
        this.innerValue = val
      },
      innerValue(val) {
        this.$emit("update:modelValue", val)
      }
    }
};
</script>